import { useQuery } from '@tanstack/react-query';
import { getApiV1MetadataSmdaMetadataGeologyStandards } from '../api/generated';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchGrossDepData = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.smdaGDE(),
    queryFn: () => getApiV1MetadataSmdaMetadataGeologyStandards(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 10 * 60 * 1000,
  });

  return query;
};
